import { createContext, type Context, type MutableRefObject } from 'react';

// While `current` is true the card ignores close requests, so content can keep it open under an
// overlay portalled to `<body>` (popup treats clicks on that overlay as outside clicks).
export const CardCloseGuardContext: Context<MutableRefObject<boolean> | null> =
	createContext<MutableRefObject<boolean> | null>(null);
